import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import styled from 'styled-components';
import { LoadingView, ModalCloseButton, SubmittedView } from './modelView';
import Model from '../Model';
import WaitingImg from '../../assets/image/model/waiting@2x.png';
import ErrImg from '../../assets/image/model/failed@2x.png';
import submitImg from '../../assets/image/model/submit@2x.png';
const StatusPanel = styled.div `
  width: 540rem;
  height: 286rem;
  box-sizing: border-box;
  background: #1C1C20;
  border-radius: 24rem;
  padding: 0 48rem;
  display: flex;
  font-family: var(--netx-font);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  ${({ theme }) => theme.mediaWidth.upToSmall `
    width: min(343rem, calc(100vw - 32rem));
    height: auto;
    min-height: 182rem;
    border-radius: 16rem;
    padding: 32rem 24rem 28rem;
    margin: 0 auto;
  `};
`;
const StatusTitle = styled.div `
  font-family: var(--netx-font);
  font-weight: 600;
  font-size: 16rem;
  color: #FFFFFF;
  line-height: 20rem;
  margin: 22rem 0 12rem;
  ${({ theme }) => theme.mediaWidth.upToSmall `
    width: fit-content;
    height: fit-content;
    font-size: 14rem;
    line-height: 18rem;
    margin: 16rem 0 8rem;
  `};
`;
const StatusIcon = styled.img `
  width: 58rem;
  height: 58rem;
  display: block;
  margin: 0 auto;
  ${({ theme }) => theme.mediaWidth.upToSmall `
    width: 42rem;
    height: 42rem;
  `};
`;
function ConfirmationPendingContent({ onDismiss, pendingText = '' }) {
    return (_jsx(_Fragment, { children: _jsxs(LoadingView, { onDismiss: onDismiss, message: pendingText || 'Please confirm this transaction in your wallet.', children: [_jsx(StatusIcon, { src: WaitingImg, alt: "" }), _jsx(StatusTitle, { children: "Waiting for confirmation" })] }) }));
}
function TransactionSubmittedContent({ onDismiss, hash, chainId, }) {
    return (_jsx(_Fragment, { children: _jsx(SubmittedView, { onDismiss: onDismiss, hash: hash, chainId: chainId, children: _jsx(StatusIcon, { src: submitImg, alt: "" }) }) }));
}
const ShowText = styled.div `
    width: 300rem;
    font-family: var(--netx-font);
    font-weight: 300;
    font-size: 12rem;
    color: #A2A2A2;
    line-height: 16rem;
    text-align: center;
    word-wrap: break-word;
    ${({ theme }) => theme.mediaWidth.upToSmall `
    width: 100%;
    max-width: 236rem;
    height: fit-content;
    font-size: 11rem;
    line-height: 16rem;
    text-align: center
  `};


`;
const defaultErrorMessage = 'You have canceled the wallet signature for this transaction, please try again.';
export function TransactionErrorContent({ message, onDismiss, title }) {
    const displayMessage = message || defaultErrorMessage;
    return (_jsxs(StatusPanel, { children: [_jsx(ModalCloseButton, { onDismiss: onDismiss }), _jsx(StatusIcon, { src: ErrImg, alt: "" }), _jsx(StatusTitle, { children: title || 'Transaction canceled' }), _jsx(ShowText, { children: displayMessage })] }));
}
export function WallectStatusModel({ isOpen, onDismiss, attemptingTxn, hash, pendingText, content, error, errorMsg, chainId, }) {
    // if (!chainId) return null
    // confirmation screen
    return (_jsx(Model, { isOpen: isOpen, onDismiss: onDismiss, children: attemptingTxn ? (_jsx(ConfirmationPendingContent, { onDismiss: onDismiss, pendingText: pendingText || '' })) : error ? (_jsx(TransactionErrorContent, { message: errorMsg || '', onDismiss: onDismiss })) : hash ? (_jsx(_Fragment, { children: _jsx(TransactionSubmittedContent, { hash: hash, chainId: chainId, onDismiss: onDismiss }) })) : (content && content()) }));
}
